export default function (price) {
  let Price = price
  if (price !== 0 && price.indexOf('.') !== -1) {
    Price = price.split('.')[0]
  }

  if (price === '0' || Price === '') {
    return '0'
  } else if (price.indexOf('-') !== -1) {
    Price = Price.split('-')[1]
    Price = parseInt(Price)
    Price = Price.toLocaleString('ko-KR')
    return '-' + Price
  }

  // if (Number(Price) < 1000) {
  //     return Price;
  // }

  Price = parseInt(Price)

  return Price.toLocaleString('ko-KR')
}
